import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';


const ConversionFunnelChart = ({ deals = [] }) => {
  const [funnelData, setFunnelData] = useState([]);

  useEffect(() => {
    if (!deals || deals?.length === 0) {
      setFunnelData([]);
      return;
    }

    // Calculate funnel stages from real data
    const stages = [
      { stage: 'new', label: 'New Leads', color: 'bg-blue-500' },
      { stage: 'qualified', label: 'Qualified', color: 'bg-indigo-500' },
      { stage: 'proposal', label: 'Proposal', color: 'bg-purple-500' },
      { stage: 'negotiation', label: 'Negotiation', color: 'bg-pink-500' },
      { stage: 'won', label: 'Won', color: 'bg-success' }
    ];

    const totalDeals = deals?.length;
    const stageData = stages?.map(s => {
      const count = deals?.filter(d => d?.stage === s?.stage)?.length;
      const percentage = totalDeals > 0 ? ((count / totalDeals) * 100)?.toFixed(1) : 0;
      return {
        ...s,
        count,
        percentage: parseFloat(percentage),
        width: percentage
      };
    });

    setFunnelData(stageData);
  }, [deals]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="bg-card border border-border rounded-xl p-6"
    >
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-foreground mb-1">Conversion Trends</h3>
        <p className="text-sm text-muted-foreground">8-week conversion rate sparklines by rep</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {funnelData?.map((stage) => (
          <motion.div
            key={stage?.stage}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3, delay: 0.05 * funnelData?.indexOf(stage) }}
            className="bg-muted/20 rounded-lg p-4 hover:bg-muted/30 transition-colors"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-foreground truncate">{stage?.label}</p>
              </div>
              <div className="text-right ml-2">
                <p className="text-lg font-semibold text-foreground">{stage?.percentage}%</p>
              </div>
            </div>
            
            <div className="h-12 -mx-1">
              <div className={`h-full ${stage?.color} rounded-lg`} style={{ width: `${stage?.width}%` }} />
            </div>
            
            <div className="mt-3 flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <div 
                  className="w-2 h-2 rounded-full"
                  style={{ backgroundColor: stage?.color }}
                />
                <span className="text-xs text-muted-foreground">8W Trend</span>
              </div>
              <div className="text-xs text-muted-foreground">
                {stage?.count} / {funnelData?.length}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
      {/* Summary section with minimal styling */}
      <div className="mt-6 pt-6 border-t border-border">
        <div className="grid grid-cols-3 gap-6 text-center">
          <div>
            <p className="text-2xl font-semibold text-foreground">86.2%</p>
            <p className="text-xs text-muted-foreground">Avg Rate</p>
          </div>
          <div>
            <p className="text-2xl font-semibold text-green-600">+5.8%</p>
            <p className="text-xs text-muted-foreground">Team Growth</p>
          </div>
          <div>
            <p className="text-2xl font-semibold text-foreground">6</p>
            <p className="text-xs text-muted-foreground">Active Reps</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ConversionFunnelChart;